/** * 系统操作日志 */
<template>
	<div>
		<topTab ref="topTab" :tabData='tabData' @tabChange='changePages'>
            <mainLog ref="mainLog" v-if="activeTab === '1'"></mainLog>
            <statistic ref="statistic" v-if="activeTab === '2'"></statistic>
		</topTab>
	</div>

</template>

<script>
import statistic from './statistic.vue'
import mainLog from './main.vue'
export default {
	data() {
		return {
			activeTab: '1',
			tabData: [{
				key: '1',
				value: '登录日志记录'
			},{
				key: '2',
				value: '登录日志统计'
			}]
		};
	},
	// 注册组件
	components: {
		statistic,
		mainLog
	},
	/**
	 * 创建完毕
	 */
	created() {
	},
	computed: {},
	/**
	 * 里面的方法只有被调用才会执行
	 */
	methods: {
    changePages(tab) {
      this.activeTab = tab;
    },
	},
};
</script>

<style scoped>
</style>